<button [ngClass]="{
        'drop-shadow': themeService.buttonConfig().primary.shadow,
        'size-extra-small': size === 'extra-small',
        'size-small': size === 'small',
        'size-medium': size === 'medium',
        'size-large': size === 'large',
        'typography--text--size--extra-small': size === 'extra-small',
        'typography--text--size--small': size === 'small',
        'typography--text--size--medium': size === 'medium',
        'typography--text--size--large': size === 'large',
        'outline': themeService.buttonConfig().primary.outline,
        'hug': layout === 'hug',
        'fill': layout === 'fill',
        'gradient': themeService.buttonConfig().primary.gradient,
    }" class="typography--text typography--text--size--medium typography--weight--semi-bold"
    [style.backgroundColor]="buttonBgColor" *ngIf="formattedAmount">
    <span class="ascii-icon">+</span>
    <span class="content" [style.text-transform]="themeService.buttonConfig().textTransform">
        {{ formattedAmount }}
    </span>

</button>